import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  ListProps,
} from 'react-admin'

const ImagesFilter = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="q" alwaysOn />
    </Filter>
  )
}

export const ListImages: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      // filters={<ImagesFilter />}
      {...rest}
      data-testid="list"
    >
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" />
        <TextField label="Tipo" source="type" />
        <TextField label="Path" source="path" />
        <TextField label="Alt" source="alt" />
      </Datagrid>
    </List>
  )
}
